import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiProductsService } from 'src/app/services';

@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.css']
})
export class ProductEditComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  id: string;
  productsData: any[] = [];
  addinfoAction: string;

  constructor(
    private apiProductService: ApiProductsService,
    private currentRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.id = this.currentRoute.snapshot.paramMap.get('id');

    this.getBasisInfo();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getBasisInfo(): void {

    this.subscriptions.add(

      this.apiProductService.info(this.id).subscribe(response => { console.log('[RESPONSE] getProductInfo: ', response);

        if(response != null) {

          this.productsData.push({...response.result});
          this.productsData[0]['checked'] = true;
        }
      })
    );
  }

  toProfile(){

    this.router.navigate(['products', 'profile', this.id]);
  }


  /**
   * 
   */
  onUpdate(): void {

    this.addinfoAction = 'update';
    setTimeout(()=>{ this.addinfoAction = ''; }, 100); // <-- перенести в сервис использовать через observable, subscription
  }
}
